import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { featureFlagReducer } from '@surfline/web-common/dist/features';
import status from './status';
import map from './map';
import spot from './spot';
import units from './units';
import animations from './animations';
import subregion from './subregion';
import user from './user';
import worldTaxonomy from './worldTaxonomy';
import components from './components';
import sessions from './sessions';
import swellEvents from './swellEvents';
import promotions from './promotions';
import deviceData from './deviceData';

export default history =>
  combineReducers({
    map,
    units,
    router: connectRouter(history),
    status,
    animations,
    spot,
    sessions,
    subregion,
    user,
    flags: featureFlagReducer,
    worldTaxonomy,
    components,
    swellEvents,
    promotions,
    deviceData,
  });
